import React, { useState } from 'react';
import SOPSidebar from './SOPSidebar';
import DocumentLibrary from './DocumentLibrary';
import SharePointSync from './SharePointSync';
import UploadDocuments from './UploadDocuments';
import SOPChat from './SOPChat';

const PAGES = {
  chat: SOPChat,
  library: DocumentLibrary,
  sharepoint: SharePointSync,
  upload: UploadDocuments,
};

export default function SOPPortal() {
  const [activePage, setActivePage] = useState('chat');
  const PageComponent = PAGES[activePage] || DocumentLibrary;

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: '#080E24',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <SOPSidebar activePage={activePage} onNavigate={setActivePage} />
      <main style={{
        flex: 1,
        padding: '32px 40px',
        overflowY: 'auto',
        maxWidth: 1200,
      }}>
        <PageComponent />
      </main>
    </div>
  );
}
